import { type ReactElement, type ReactNode } from "react";
import { useGlobalLayout } from "../../../hooks/useGlobalLayout.ts";
import { C100Navigation } from "../../cms-components/C100Navigation/C100Navigation.tsx";
import { C102Footer } from "../../cms-components/C102Footer/C102Footer.tsx";

interface AppLayoutProps {
  children: ReactNode;
}

export function AppLayout({ children }: AppLayoutProps): ReactElement {
  const { navigationData, footerData } = useGlobalLayout();

  return (
    <div className="app-layout">
      {/* Navigation - always rendered if available */}
      {navigationData && <C100Navigation {...navigationData} />}

      {/* Main content area */}
      <main className="app-main">{children}</main>

      {/* Footer - always rendered if available */}
      {footerData && <C102Footer {...footerData} />}
    </div>
  );
}
